module.exports = __webpack_public_path__ + "img/LogoLG2016.ffa2b94f.png";